import { render, staticRenderFns } from "./EditorMenuGroup.vue?vue&type=template&id=1271b8f0&scoped=true&"
import script from "./EditorMenuGroup.vue?vue&type=script&lang=js&"
export * from "./EditorMenuGroup.vue?vue&type=script&lang=js&"
import style0 from "./EditorMenuGroup.vue?vue&type=style&index=0&id=1271b8f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1271b8f0",
  null
  
)

export default component.exports